import React, { useEffect, useState } from 'react';

import { useTranslation, Trans } from "react-i18next";

import d1 from '../../img/AboutUs/k1.webp';
import d2 from '../../img/AboutUs/k2.webp';
import d3 from '../../img/AboutUs/k3.webp';
import d4 from '../../img/AboutUs/k4.webp';

import arrow from '../../img/Home/arrow.svg'

import Fade from 'react-reveal/Fade'

import { Link } from "react-router-dom"

function KeyElements () {

    const { t } = useTranslation();

    const [active, setActive] = useState(0);

    const data = [
        {
            title: t('about.22'),
            text: t('about.23'),
            img: d1,
        },
        {
            title: t('about.24'),
            text: t('about.25'),
            img: d2,
        },
        {
            title: t('about.26'),
            text: t('about.27'),
            img: d3,
        },
        {
            title: t('about.28'),
            text: t('about.29'),
            img: d4,
        }
    ]
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex flex-col items-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center xl:max-w-[660px]"><Trans>{t('about.21')}</Trans></p>
                </div>
                <div className='flex flex-wrap xl:hidden mt-[35px] gap-[2px]'>
                    {data.map((item, index) =>(
                        <div key={index} className={`h-[50px] w-[164px] flex-grow flex items-center justify-center cursor-pointer transition-all ${active === index ? 'bg-[#F26522]' : 'bg-[#272727]'}`} onClick={() => setActive(index)}>
                            <p className={`open-sans font-[300] text-[14px] xl:text-[16px] transition-all text-center px-[5px] ${active === index ? 'text-[#1D1D1D]' : 'text-[#F6F6F6]'}`}>{item.title}</p>
                        </div>
                    ))}
                </div>
                <div className='flex xl:hidden mx-[-20px] md:mx-[-40px] mt-[30px] relative overflow-hidden'>
                    <img src={data[active].img} alt="" className='w-full h-[295px] object-cover'/>
                    <div className="absolute inset-0 bg-gradient-to-r from-black/80 to-black/80" />
                    <Fade bottom key={active}>
                        <div className='absolute top-[20px] left-0 right-0 p-4 flex flex-col items-center transition-all duration-1000 max-h-[120px] group-hover:max-h-[500px]'>
                            <p className='text-[16px] xl:text-[20px] open-sans text-[#F26522] text-center'>{data[active].title}</p>
                            <p className='max-w-[415px] text-[#F6F6F6] open-sans font-[300] text-[14px] xl:text-[16px] text-center mt-[15px]'>
                                {data[active].text} 
                            </p>
                            <Link to="/form"><div className='buttond mt-[50px]'>
                                <p className='montserrat text-[#F6F6F6] font-[600] text-[14px] md:text-[16px]'>{t('home.5')}</p>
                            </div></Link>
                        </div>
                    </Fade>
                </div>
                <div className='hidden xl:grid grid-cols-2 gap-[35px] mt-[30px] xl:mt-[65px]'>
                    {data.map((item, index) => (
                        <Fade left={index % 2 === 0} right={index % 2 !== 0} duration={1000}>
                            <div className='relative group overflow-hidden' key={index}>
                            <img src={item.img} alt="" className='w-full h-auto' />
                            <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-black/50" />
                            <div className='absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 flex flex-col items-center transition-all duration-1000 max-h-[120px] group-hover:max-h-[500px]'>
                                <p className='text-[16px] xl:text-[20px] open-sans text-[#F26522] text-center'>{item.title}</p>
                                <p className='max-w-[415px] text-[#F6F6F6] open-sans font-[300] text-[14px] xl:text-[16px] text-center overflow-hidden text-ellipsis line-clamp-1 group-hover:line-clamp-none transition-all duration-500'>
                                    {item.text}
                                </p>
                                <Link to="/form"><div className='buttond mt-[50px] xl:hidden group-hover:block hover:scale-[1.1]'>
                                    <p className='montserrat text-[#F6F6F6] font-[600] text-[14px] md:text-[16px]'>{t('home.5')}</p>
                                </div></Link>
                            </div>
                            </div>
                        </Fade>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default KeyElements;